import React from 'react';
import {useColorScheme} from 'shared/lib/hooks';
import styled from 'styled-components';

const EmptyContainer = styled.div<{size?: string}>`
  width: ${({size}) => size};
  height: ${({size}) => size};
  align-self: center;
  margin-top: 58px;
`;

export const EmptyReview = ({size = '300px'}: {size?: string}) => {
  const colorScheme = useColorScheme();
  return (
    <EmptyContainer size={size}>
      {colorScheme === 'light' ? (
        <svg
          width={size}
          height={size}
          viewBox="0 0 400 400"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M204.328 318.689C272.209 318.689 327.238 263.611 327.238 195.669C327.238 127.727 272.209 72.6492 204.328 72.6492C136.446 72.6492 81.4175 127.727 81.4175 195.669C81.4175 263.611 136.446 318.689 204.328 318.689Z"
            fill="#EAEEF9"
          />
          <path
            d="M350.03 223.605C355.22 223.605 359.428 219.393 359.428 214.199C359.428 209.004 355.22 204.793 350.03 204.793C344.84 204.793 340.633 209.004 340.633 214.199C340.633 219.393 344.84 223.605 350.03 223.605Z"
            fill="#EAEEF9"
          />
          <path
            d="M92.2998 111.104C95.7143 111.104 98.4824 108.333 98.4824 104.916C98.4824 101.498 95.7143 98.7275 92.2998 98.7275C88.8852 98.7275 86.1172 101.498 86.1172 104.916C86.1172 108.333 88.8852 111.104 92.2998 111.104Z"
            fill="#EAEEF9"
          />
          <path
            d="M193.941 296.2C193.941 307.833 188.995 318.23 181.082 325.655C178.856 327.636 176.63 329.368 173.91 330.853C167.975 334.319 161.05 336.299 153.631 336.299C146.212 336.299 139.287 334.319 133.352 330.853C132.363 330.358 131.621 329.863 130.632 329.121C120.245 321.942 113.32 309.814 113.32 296.2C113.32 273.923 131.374 256.101 153.384 256.101C175.888 255.853 193.941 273.923 193.941 296.2Z"
            fill="#DCE2F0"
          />
          <path
            d="M145.469 305.114C145.964 305.609 146.458 306.352 147.2 306.847C147.695 307.342 148.189 307.59 148.684 308.085C148.931 308.332 149.426 308.58 149.673 308.827C149.673 308.827 149.92 308.827 149.92 309.075L150.168 309.322V312.788C150.168 312.788 150.168 312.788 149.92 312.54C149.673 312.293 149.178 312.045 148.931 311.798C148.437 311.55 147.942 311.055 147.447 310.807C147.2 310.807 147.2 310.56 146.953 310.56C145.222 309.57 143.738 308.58 143.738 307.342C143.985 306.847 144.48 306.104 145.469 305.114ZM180.586 324.421C179.102 321.204 176.382 317.986 172.92 316.253C171.189 315.51 169.21 314.768 167.232 314.768C166.737 314.768 165.995 314.768 165.501 314.768C165.253 314.768 165.006 314.768 164.759 314.768C162.038 314.52 161.791 314.025 161.791 314.025V308.332C163.522 306.847 165.253 305.114 166.737 303.382C167.974 301.649 168.963 299.669 169.457 297.194C171.683 296.699 173.167 294.718 172.92 292.243C172.92 291.253 172.178 290.263 172.178 289.273C172.178 288.778 172.178 288.283 172.178 287.788C172.178 287.54 172.178 287.045 172.178 286.797C172.178 286.55 172.178 286.055 172.178 285.807C171.93 284.075 171.436 282.342 170.447 280.362C167.479 274.916 162.038 271.451 155.608 271.451C154.372 271.451 153.135 271.698 151.899 271.946C149.673 272.441 147.447 273.431 145.716 274.916C145.469 275.164 144.974 275.411 144.727 275.906L144.48 276.154C142.501 278.134 140.77 280.362 140.028 283.085C139.039 285.807 139.039 288.53 139.286 291.253C139.286 291.253 139.286 291.253 139.286 291.5V291.748C139.286 292.243 139.534 292.243 139.286 292.491C139.286 292.738 139.039 292.738 139.039 292.986C138.544 293.728 138.297 294.718 138.792 296.203C139.781 298.679 141.265 298.431 142.996 299.669C142.996 299.669 142.749 299.669 142.749 299.916L141.017 300.411C133.104 302.887 130.383 309.57 133.846 313.778C135.082 315.263 137.061 316.501 140.028 317.243C139.286 317.243 138.544 317.738 138.05 318.233C134.588 320.956 132.362 325.164 131.867 329.124C131.867 329.372 131.867 329.619 131.867 329.867C132.856 330.362 133.598 331.105 134.588 331.6H173.909C176.382 330.114 178.855 328.382 181.081 326.402C180.833 325.164 180.833 324.669 180.586 324.421Z"
            fill="white"
          />
          <path
            d="M181.083 325.659C178.857 327.639 176.631 329.372 173.911 330.857C167.976 334.322 161.051 336.303 153.632 336.303C146.213 336.303 139.288 334.322 133.353 330.857C132.364 330.362 131.622 329.867 130.633 329.124C130.633 328.877 130.633 328.629 130.633 328.382C131.127 324.421 133.353 320.213 136.815 317.491C137.31 316.996 138.052 316.748 138.794 316.501C135.826 316.005 133.848 314.768 132.611 313.035H142.009C144.729 316.748 148.933 318.976 153.879 318.976C158.084 318.976 161.793 317.243 164.513 314.52C164.761 314.52 165.008 314.52 165.255 314.52C165.75 314.52 166.245 314.52 166.987 314.52C168.965 314.52 170.943 315.015 172.675 316.005C176.137 317.738 178.61 320.708 180.341 324.174C180.836 324.669 180.836 325.164 181.083 325.659Z"
            fill="#EAEEF9"
          />
          <path
            d="M162.041 308.332V313.53L146.461 314.025L147.203 310.56C147.45 310.56 147.45 310.807 147.697 310.807C148.192 311.055 148.687 311.55 149.181 311.797C149.429 312.045 149.676 312.292 150.171 312.54C150.171 312.54 150.418 312.54 150.418 312.787V309.322L150.171 309.075C152.891 310.56 156.6 311.55 162.041 308.332Z"
            fill="url(#paint0_linear_8730_44087)"
          />
          <path
            d="M172.18 286.797C169.212 287.787 165.75 288.282 162.535 288.035C157.341 287.54 152.395 285.56 148.439 282.094C147.202 285.807 143.987 288.53 140.277 290.263C139.783 290.51 139.288 290.758 138.794 290.758C138.794 290.758 138.794 290.758 138.794 290.51C138.546 287.787 138.546 285.064 139.536 282.342C140.277 279.619 142.009 277.391 143.987 275.411L144.234 275.163C144.482 274.916 144.976 274.668 145.224 274.173C146.955 272.688 149.18 271.698 151.406 271.203C152.643 270.956 153.879 270.708 155.116 270.708C161.546 270.708 167.234 274.173 169.954 279.619C170.943 281.599 171.438 283.579 171.685 285.064C172.18 286.055 172.18 286.55 172.18 286.797Z"
            fill="#A2ABBC"
          />
          <path
            d="M152.396 323.429C150.912 325.162 148.439 325.162 146.213 325.162C148.439 322.934 147.202 315.756 139.289 316.498C128.407 314.518 129.397 303.132 140.278 299.667L142.009 299.172L142.256 299.419C142.998 301.647 144.235 303.627 145.471 305.112C141.02 308.825 147.202 309.815 150.17 312.786C152.643 314.271 154.869 320.459 152.396 323.429Z"
            fill="#A2ABBC"
          />
          <path
            d="M193.941 296.2C193.941 307.833 188.995 318.23 181.082 325.655C178.856 327.636 176.63 329.368 173.91 330.853C167.975 334.319 161.05 336.299 153.631 336.299C146.212 336.299 139.287 334.319 133.352 330.853C132.363 330.358 131.621 329.863 130.632 329.121C120.245 321.942 113.32 309.814 113.32 296.2C113.32 273.923 131.374 256.101 153.384 256.101C175.888 255.853 193.941 273.923 193.941 296.2Z"
            stroke="white"
            strokeWidth="1.6434"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M305.226 197.686C305.226 208.825 300.774 218.726 293.85 226.152C293.355 226.894 292.613 227.389 291.871 227.884C284.452 234.815 274.56 239.023 263.679 239.023C255.023 239.023 246.862 236.3 240.185 231.597C238.206 230.359 236.475 228.627 234.744 227.142C227.078 219.716 222.379 209.32 222.379 197.686C222.379 174.914 240.927 156.349 263.679 156.349C286.678 156.349 305.226 174.914 305.226 197.686Z"
            fill="#E9F0F8"
          />
          <path
            d="M305.226 197.688C305.226 209.817 300.032 220.46 291.871 228.134C284.452 235.064 274.56 239.272 263.679 239.272C255.023 239.272 246.862 236.55 240.185 231.847C229.303 224.421 222.379 212.045 222.379 197.936C222.379 175.163 240.927 156.599 263.679 156.599C286.431 156.599 305.226 174.916 305.226 197.688Z"
            fill="#DCE2F0"
          />
          <path
            d="M293.852 226.15C293.357 226.892 292.615 227.387 291.873 227.882C284.454 234.813 274.562 239.021 263.681 239.021C255.025 239.021 246.864 236.298 240.187 231.595C238.208 230.358 236.477 228.625 234.746 227.14C235.735 225.902 237.219 225.16 240.434 223.922L241.671 223.427C244.144 222.437 247.606 221.199 252.057 219.219C252.799 218.971 253.294 218.476 253.789 217.981C254.036 217.734 254.283 217.486 254.283 216.991C254.53 216.496 254.778 215.754 254.778 215.259V206.843C254.53 206.595 254.53 206.595 254.283 206.348C253.541 205.358 253.047 204.12 253.047 202.635L252.552 202.387C250.326 202.882 250.574 200.655 250.079 196.199C249.832 194.466 250.079 193.971 251.068 193.724L251.81 192.734C250.326 189.268 249.584 186.051 249.584 183.575C249.584 179.367 251.315 176.645 253.789 175.407C252.305 172.437 252.305 171.447 252.305 171.447C252.305 171.447 260.96 172.932 263.928 172.437C267.638 171.694 273.573 172.684 275.799 177.635C279.508 179.12 280.745 181.348 281.239 183.823C281.734 187.783 279.508 191.991 279.014 193.724V193.971C279.508 194.219 279.755 194.714 279.508 196.447C279.014 200.655 279.014 203.13 277.035 202.635L275.057 206.1C275.057 206.595 275.057 206.595 274.809 206.843C274.809 207.585 274.809 208.823 274.809 215.506C274.809 216.249 275.057 217.239 275.551 217.734C275.799 217.981 275.799 218.229 276.046 218.229C276.541 218.724 277.035 219.219 277.53 219.219C282.476 221.199 285.938 222.684 288.658 223.674C291.131 224.665 292.863 225.407 293.852 226.15Z"
            fill="white"
          />
          <path
            d="M293.852 226.152C293.357 226.894 292.615 227.389 291.873 227.884C284.454 234.815 274.562 239.023 263.681 239.023C255.025 239.023 246.864 236.3 240.187 231.597C238.208 230.36 236.477 228.627 234.746 227.142C235.735 225.904 237.219 225.162 240.434 223.924L241.671 223.429C244.144 222.439 247.606 221.201 252.057 219.221C252.799 218.974 253.294 218.478 253.789 217.983C256.262 221.449 260.218 223.676 264.917 223.676C269.369 223.676 273.326 221.449 275.799 218.231C276.293 218.726 276.788 219.221 277.282 219.221C282.229 221.201 285.691 222.686 288.411 223.676C291.131 224.667 292.863 225.409 293.852 226.152Z"
            fill="#EAEEF9"
          />
          <path
            d="M278.766 193.476C279.014 192.485 278.519 191 278.024 190.258C278.024 190.01 277.777 190.01 277.777 189.763C276.046 186.297 272.336 185.06 268.874 184.812C259.724 184.317 258.982 186.05 256.262 183.575C257.251 184.812 257.251 187.04 255.767 189.515C254.778 191.248 253.047 192.238 251.315 192.733C247.111 183.327 249.337 177.386 253.294 175.406C251.81 172.436 251.81 171.446 251.81 171.446C251.81 171.446 260.466 172.931 263.433 172.436C267.143 171.693 273.078 172.683 275.304 177.634C279.014 179.119 280.25 181.347 280.745 183.822C281.487 187.535 279.261 191.743 278.766 193.476Z"
            fill="#A2ABBC"
          />
          <path
            d="M255.026 215.257V206.841C254.779 206.594 254.779 206.594 254.531 206.346V205.851C255.026 206.594 255.52 207.336 256.262 207.832L262.94 212.534C264.423 213.772 266.649 213.772 268.133 212.534L274.316 207.089C274.563 206.841 274.81 206.841 275.058 206.594C275.058 207.336 275.058 208.574 275.058 215.257C275.058 215.752 275.058 216 275.305 216.495H255.026C254.779 216 255.026 215.752 255.026 215.257Z"
            fill="url(#paint1_linear_8730_44087)"
          />
          <path
            d="M305.226 197.688C305.226 209.817 300.032 220.46 291.871 228.134C284.452 235.064 274.56 239.272 263.679 239.272C255.023 239.272 246.862 236.55 240.185 231.847C229.303 224.421 222.379 212.045 222.379 197.936C222.379 175.163 240.927 156.599 263.679 156.599C286.431 156.599 305.226 174.916 305.226 197.688Z"
            stroke="white"
            strokeWidth="1.6604"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28 226.4C28 234.32 34.4299 240.756 42.3436 240.756H169.458C170.695 240.756 171.931 241.251 172.673 241.994L190.479 259.815C190.973 260.558 191.963 260.806 192.952 260.311C193.694 260.063 194.436 259.073 194.436 258.33V175.904C194.436 167.984 188.006 161.548 180.092 161.548H42.3436C34.4299 161.548 28 167.984 28 175.904V226.4Z"
            fill="#CED6E2"
          />
          <path
            d="M133.656 102.28C133.656 110.201 140.086 116.637 148 116.637H169.457C170.694 116.637 171.93 117.132 172.672 117.874L190.478 135.696C190.973 136.439 191.962 136.686 192.951 136.191C193.693 135.944 194.435 134.954 194.435 134.211V76.3565C194.435 68.4357 188.005 62 180.091 62H148C140.086 62 133.656 68.4357 133.656 76.3565V102.28Z"
            fill="#CED6E2"
          />
          <path
            opacity="0.7"
            d="M163.275 193.727H53.9667C52.9775 193.727 51.9883 192.737 51.9883 191.747V185.311C51.9883 184.321 52.9775 183.331 53.9667 183.331H163.275C164.264 183.331 165.254 184.321 165.254 185.311V191.747C165.254 192.985 164.512 193.727 163.275 193.727Z"
            fill="url(#paint2_linear_8730_44087)"
          />
          <path
            opacity="0.7"
            d="M121.233 220.708H53.9667C52.9775 220.708 51.9883 219.717 51.9883 218.727V212.292C51.9883 211.302 52.9775 210.312 53.9667 210.312H121.233C122.223 210.312 123.212 211.302 123.212 212.292V218.727C123.212 219.965 122.47 220.708 121.233 220.708Z"
            fill="url(#paint3_linear_8730_44087)"
          />
          <path
            d="M371.998 129.12C371.998 136.298 366.31 141.991 359.138 141.991H244.884C243.894 141.991 242.658 142.486 241.916 143.229L225.841 159.318C225.347 159.813 224.357 160.061 223.615 159.813C222.874 159.566 222.379 158.823 222.379 158.08V83.8227C222.379 76.6445 228.067 70.9514 235.239 70.9514H358.891C366.063 70.9514 371.751 76.6445 371.751 83.8227V129.12H371.998Z"
            fill="#CED6E2"
          />
          <path
            opacity="0.7"
            d="M346.528 99.9138H248.348C247.359 99.9138 246.617 99.1712 246.617 98.1811V92.2405C246.617 91.2504 247.359 90.5078 248.348 90.5078H346.528C347.517 90.5078 348.259 91.2504 348.259 92.2405V98.1811C348.259 99.1712 347.517 99.9138 346.528 99.9138Z"
            fill="url(#paint4_linear_8730_44087)"
          />
          <path
            opacity="0.7"
            d="M308.938 124.168H248.348C247.359 124.168 246.617 123.426 246.617 122.436V116.495C246.617 115.505 247.359 114.762 248.348 114.762H308.938C309.927 114.762 310.669 115.505 310.669 116.495V122.436C310.669 123.178 309.68 124.168 308.938 124.168Z"
            fill="url(#paint5_linear_8730_44087)"
          />
          <path
            d="M164.096 73.3721C155.24 73.3721 148.125 80.5592 148.125 89.3435C148.125 98.1278 155.312 105.315 164.096 105.315C172.881 105.315 180.068 98.2004 180.068 89.3435C180.068 80.5592 172.953 73.4447 164.096 73.3721ZM170.195 81.4304C171.647 81.4304 172.808 82.5919 172.808 84.0439C172.808 85.4958 171.647 86.6574 170.195 86.6574C168.743 86.6574 167.581 85.4958 167.581 84.0439C167.581 82.5919 168.743 81.4304 170.195 81.4304ZM158.071 81.3578C159.523 81.3578 160.684 82.5193 160.684 83.9713C160.684 85.4232 159.523 86.5848 158.071 86.5848C156.619 86.5848 155.457 85.4232 155.457 83.9713C155.457 82.5919 156.619 81.3578 158.071 81.3578ZM173.316 93.046C171.356 98.1278 165.694 100.669 160.612 98.7812C157.998 97.7648 155.893 95.6595 154.877 93.046C154.659 92.3926 154.949 91.7392 155.603 91.5214C155.748 91.4488 155.893 91.4488 156.038 91.4488H172.155C172.808 91.4488 173.389 92.0296 173.389 92.683C173.389 92.7556 173.389 92.9008 173.316 93.046Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8730_44087"
              x1="154.221"
              y1="313.848"
              x2="154.221"
              y2="310.866"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="white" />
              <stop offset="0.9913" stopColor="#D6DEEA" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_8730_44087"
              x1="264.878"
              y1="216.163"
              x2="264.878"
              y2="210.588"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="white" />
              <stop offset="0.9913" stopColor="#D6DEEA" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_8730_44087"
              x1="168.281"
              y1="188.499"
              x2="52.7869"
              y2="188.499"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.00651336" stopColor="#A6AEBE" stopOpacity="0" />
              <stop offset="1" stopColor="#A6AAB5" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_8730_44087"
              x1="125.116"
              y1="215.48"
              x2="52.4905"
              y2="215.48"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.00651336" stopColor="#A6AEBE" stopOpacity="0" />
              <stop offset="1" stopColor="#A6AAB5" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_8730_44087"
              x1="350.976"
              y1="95.1838"
              x2="247.334"
              y2="95.1838"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.00651336" stopColor="#A6AEBE" stopOpacity="0" />
              <stop offset="1" stopColor="#A6AAB5" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_8730_44087"
              x1="312.381"
              y1="119.438"
              x2="247.069"
              y2="119.438"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.00651336" stopColor="#A6AEBE" stopOpacity="0" />
              <stop offset="1" stopColor="#A6AAB5" />
            </linearGradient>
          </defs>
        </svg>
      ) : (
        <svg
          width={size}
          height={size}
          viewBox="0 0 400 400"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M204.328 318.69C272.209 318.69 327.238 263.612 327.238 195.67C327.238 127.727 272.209 72.6494 204.328 72.6494C136.446 72.6494 81.4175 127.727 81.4175 195.67C81.4175 263.612 136.446 318.69 204.328 318.69Z"
            fill="#2A2E37"
          />
          <path
            d="M350.03 223.605C355.22 223.605 359.428 219.394 359.428 214.199C359.428 209.004 355.22 204.793 350.03 204.793C344.84 204.793 340.633 209.004 340.633 214.199C340.633 219.394 344.84 223.605 350.03 223.605Z"
            fill="#2A2E37"
          />
          <path
            d="M92.2998 111.104C95.7143 111.104 98.4824 108.333 98.4824 104.916C98.4824 101.498 95.7143 98.7275 92.2998 98.7275C88.8852 98.7275 86.1172 101.498 86.1172 104.916C86.1172 108.333 88.8852 111.104 92.2998 111.104Z"
            fill="#2A2E37"
          />
          <g filter="url(#filter0_d_10185_8005)">
            <path
              d="M193.941 296.2C193.941 307.833 188.995 318.23 181.082 325.655C178.856 327.636 176.63 329.368 173.91 330.853C167.975 334.319 161.05 336.299 153.631 336.299C146.212 336.299 139.287 334.319 133.352 330.853C132.363 330.358 131.621 329.863 130.632 329.121C120.245 321.942 113.32 309.814 113.32 296.2C113.32 273.923 131.374 256.101 153.384 256.101C175.888 255.853 193.941 273.923 193.941 296.2Z"
              fill="url(#paint0_linear_10185_8005)"
            />
          </g>
          <path
            d="M145.469 305.115C145.964 305.61 146.458 306.352 147.2 306.847C147.695 307.342 148.189 307.59 148.684 308.085C148.931 308.332 149.426 308.58 149.673 308.828C149.673 308.828 149.92 308.828 149.92 309.075L150.168 309.323V312.788C150.168 312.788 150.168 312.788 149.92 312.54C149.673 312.293 149.178 312.045 148.931 311.798C148.437 311.55 147.942 311.055 147.447 310.808C147.2 310.808 147.2 310.56 146.953 310.56C145.222 309.57 143.738 308.58 143.738 307.342C143.985 306.847 144.48 306.105 145.469 305.115ZM180.586 324.422C179.102 321.204 176.382 317.986 172.92 316.253C171.189 315.511 169.21 314.768 167.232 314.768C166.737 314.768 165.995 314.768 165.501 314.768C165.253 314.768 165.006 314.768 164.759 314.768C162.038 314.521 161.791 314.026 161.791 314.026V308.332C163.522 306.847 165.253 305.115 166.737 303.382C167.974 301.649 168.963 299.669 169.457 297.194C171.683 296.699 173.167 294.719 172.92 292.243C172.92 291.253 172.178 290.263 172.178 289.273C172.178 288.778 172.178 288.283 172.178 287.788C172.178 287.54 172.178 287.045 172.178 286.798C172.178 286.55 172.178 286.055 172.178 285.808C171.93 284.075 171.436 282.342 170.447 280.362C167.479 274.917 162.038 271.451 155.608 271.451C154.372 271.451 153.135 271.699 151.899 271.946C149.673 272.441 147.447 273.431 145.716 274.917C145.469 275.164 144.974 275.412 144.727 275.907L144.48 276.154C142.501 278.134 140.77 280.362 140.028 283.085C139.039 285.808 139.039 288.53 139.286 291.253C139.286 291.253 139.286 291.253 139.286 291.501V291.748C139.286 292.243 139.534 292.243 139.286 292.491C139.286 292.738 139.039 292.738 139.039 292.986C138.544 293.728 138.297 294.719 138.792 296.204C139.781 298.679 141.265 298.431 142.996 299.669C142.996 299.669 142.749 299.669 142.749 299.917L141.017 300.412C133.104 302.887 130.383 309.57 133.846 313.778C135.082 315.263 137.061 316.501 140.028 317.243C139.286 317.243 138.544 317.738 138.05 318.233C134.588 320.956 132.362 325.164 131.867 329.125C131.867 329.372 131.867 329.62 131.867 329.867C132.856 330.362 133.598 331.105 134.588 331.6H173.909C176.382 330.115 178.855 328.382 181.081 326.402C180.833 325.164 180.833 324.669 180.586 324.422Z"
            fill="#8E94A7"
          />
          <path
            d="M181.083 325.659C178.857 327.64 176.631 329.372 173.911 330.857C167.976 334.323 161.051 336.303 153.632 336.303C146.213 336.303 139.288 334.323 133.353 330.857C132.364 330.362 131.622 329.867 130.633 329.125C130.633 328.877 130.633 328.63 130.633 328.382C131.127 324.422 133.353 320.214 136.815 317.491C137.31 316.996 138.052 316.749 138.794 316.501C135.826 316.006 133.848 314.768 132.611 313.036H142.009C144.729 316.749 148.933 318.976 153.879 318.976C158.084 318.976 161.793 317.244 164.513 314.521C164.761 314.521 165.008 314.521 165.255 314.521C165.75 314.521 166.245 314.521 166.987 314.521C168.965 314.521 170.943 315.016 172.675 316.006C176.137 317.739 178.61 320.709 180.341 324.174C180.836 324.669 180.836 325.164 181.083 325.659Z"
            fill="#464D60"
          />
          <path
            d="M162.041 308.332V313.53L146.461 314.025L147.203 310.56C147.45 310.56 147.45 310.807 147.697 310.807C148.192 311.055 148.687 311.55 149.181 311.797C149.429 312.045 149.676 312.292 150.171 312.54C150.171 312.54 150.418 312.54 150.418 312.787V309.322L150.171 309.075C152.891 310.56 156.6 311.55 162.041 308.332Z"
            fill="url(#paint1_linear_10185_8005)"
          />
          <path
            d="M172.18 286.797C169.212 287.787 165.75 288.282 162.535 288.035C157.341 287.54 152.395 285.56 148.439 282.094C147.202 285.807 143.987 288.53 140.277 290.263C139.783 290.51 139.288 290.758 138.794 290.758C138.794 290.758 138.794 290.758 138.794 290.51C138.546 287.787 138.546 285.064 139.536 282.342C140.277 279.619 142.009 277.391 143.987 275.411L144.234 275.163C144.482 274.916 144.976 274.668 145.224 274.173C146.955 272.688 149.18 271.698 151.406 271.203C152.643 270.956 153.879 270.708 155.116 270.708C161.546 270.708 167.234 274.173 169.954 279.619C170.943 281.599 171.438 283.579 171.685 285.064C172.18 286.055 172.18 286.55 172.18 286.797Z"
            fill="#292D35"
          />
          <path
            d="M152.396 323.429C150.912 325.162 148.439 325.162 146.213 325.162C148.439 322.934 147.202 315.756 139.289 316.498C128.407 314.518 129.397 303.132 140.278 299.666L142.009 299.171L142.256 299.419C142.998 301.647 144.235 303.627 145.471 305.112C141.02 308.825 147.202 309.815 150.17 312.785C152.643 314.27 154.869 320.459 152.396 323.429Z"
            fill="#292D35"
          />
          <path
            d="M193.941 296.2C193.941 307.833 188.995 318.23 181.082 325.655C178.856 327.636 176.63 329.368 173.91 330.853C167.975 334.319 161.05 336.299 153.631 336.299C146.212 336.299 139.287 334.319 133.352 330.853C132.363 330.358 131.621 329.863 130.632 329.121C120.245 321.942 113.32 309.814 113.32 296.2C113.32 273.923 131.374 256.101 153.384 256.101C175.888 255.853 193.941 273.923 193.941 296.2Z"
            stroke="#6F778C"
            strokeWidth="1.6434"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M305.226 197.686C305.226 208.825 300.774 218.726 293.85 226.152C293.355 226.894 292.613 227.389 291.871 227.884C284.452 234.815 274.56 239.023 263.679 239.023C255.023 239.023 246.862 236.3 240.185 231.597C238.206 230.36 236.475 228.627 234.744 227.142C227.078 219.716 222.379 209.32 222.379 197.686C222.379 174.914 240.927 156.35 263.679 156.35C286.678 156.35 305.226 174.914 305.226 197.686Z"
            fill="#E9F0F8"
          />
          <g filter="url(#filter1_d_10185_8005)">
            <path
              d="M305.226 197.688C305.226 209.817 300.032 220.461 291.871 228.134C284.452 235.065 274.56 239.273 263.679 239.273C255.023 239.273 246.862 236.55 240.185 231.847C229.303 224.421 222.379 212.045 222.379 197.936C222.379 175.164 240.927 156.599 263.679 156.599C286.431 156.599 305.226 174.916 305.226 197.688Z"
              fill="url(#paint2_linear_10185_8005)"
            />
          </g>
          <path
            d="M293.852 226.15C293.357 226.893 292.615 227.388 291.873 227.883C284.454 234.814 274.562 239.022 263.681 239.022C255.025 239.022 246.864 236.299 240.187 231.596C238.208 230.358 236.477 228.626 234.746 227.14C235.735 225.903 237.219 225.16 240.434 223.923L241.671 223.428C244.144 222.438 247.606 221.2 252.057 219.22C252.799 218.972 253.294 218.477 253.789 217.982C254.036 217.735 254.283 217.487 254.283 216.992C254.53 216.497 254.778 215.754 254.778 215.259V206.843C254.53 206.596 254.53 206.596 254.283 206.348C253.541 205.358 253.047 204.121 253.047 202.635L252.552 202.388C250.326 202.883 250.574 200.655 250.079 196.2C249.832 194.467 250.079 193.972 251.068 193.725L251.81 192.734C250.326 189.269 249.584 186.051 249.584 183.576C249.584 179.368 251.315 176.645 253.789 175.408C252.305 172.437 252.305 171.447 252.305 171.447C252.305 171.447 260.96 172.932 263.928 172.437C267.638 171.695 273.573 172.685 275.799 177.635C279.508 179.121 280.745 181.348 281.239 183.824C281.734 187.784 279.508 191.992 279.014 193.725V193.972C279.508 194.22 279.755 194.715 279.508 196.447C279.014 200.655 279.014 203.131 277.035 202.635L275.057 206.101C275.057 206.596 275.057 206.596 274.809 206.843C274.809 207.586 274.809 208.824 274.809 215.507C274.809 216.249 275.057 217.239 275.551 217.735C275.799 217.982 275.799 218.23 276.046 218.23C276.541 218.725 277.035 219.22 277.53 219.22C282.476 221.2 285.938 222.685 288.658 223.675C291.131 224.665 292.863 225.408 293.852 226.15Z"
            fill="#8E94A7"
          />
          <path
            d="M293.852 226.147C293.357 226.89 292.615 227.385 291.873 227.88C284.454 234.811 274.562 239.019 263.681 239.019C255.025 239.019 246.864 236.296 240.187 231.593C238.208 230.355 236.477 228.623 234.746 227.137C235.735 225.9 237.219 225.157 240.434 223.92L241.671 223.425C244.144 222.434 247.606 221.197 252.057 219.217C252.799 218.969 253.294 218.474 253.789 217.979C256.262 221.444 260.218 223.672 264.917 223.672C269.369 223.672 273.326 221.444 275.799 218.227C276.293 218.722 276.788 219.217 277.282 219.217C282.229 221.197 285.691 222.682 288.411 223.672C291.131 224.662 292.863 225.405 293.852 226.147Z"
            fill="#464D60"
          />
          <path
            d="M278.766 193.476C279.014 192.486 278.519 191.001 278.024 190.258C278.024 190.011 277.777 190.011 277.777 189.763C276.046 186.298 272.336 185.06 268.874 184.813C259.724 184.318 258.982 186.05 256.262 183.575C257.251 184.813 257.251 187.04 255.767 189.516C254.778 191.248 253.047 192.238 251.315 192.733C247.111 183.328 249.337 177.387 253.294 175.407C251.81 172.436 251.81 171.446 251.81 171.446C251.81 171.446 260.466 172.931 263.433 172.436C267.143 171.694 273.078 172.684 275.304 177.634C279.014 179.12 280.25 181.347 280.745 183.823C281.487 187.535 279.261 191.743 278.766 193.476Z"
            fill="#292D35"
          />
          <path
            d="M255.026 215.258V206.842C254.779 206.594 254.779 206.594 254.531 206.347V205.852C255.026 206.594 255.52 207.337 256.262 207.832L262.94 212.535C264.423 213.772 266.649 213.772 268.133 212.535L274.316 207.089C274.563 206.842 274.81 206.842 275.058 206.594C275.058 207.337 275.058 208.574 275.058 215.258C275.058 215.753 275.058 216 275.305 216.495H255.026C254.779 216 255.026 215.753 255.026 215.258Z"
            fill="url(#paint3_linear_10185_8005)"
          />
          <path
            d="M305.226 197.688C305.226 209.817 300.032 220.461 291.871 228.134C284.452 235.065 274.56 239.273 263.679 239.273C255.023 239.273 246.862 236.55 240.185 231.847C229.303 224.421 222.379 212.045 222.379 197.936C222.379 175.164 240.927 156.599 263.679 156.599C286.431 156.599 305.226 174.916 305.226 197.688Z"
            stroke="#6F778C"
            strokeWidth="1.6604"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g filter="url(#filter2_d_10185_8005)">
            <path
              d="M28 226.4C28 234.32 34.4299 240.756 42.3436 240.756H169.458C170.695 240.756 171.931 241.251 172.673 241.994L190.479 259.815C190.973 260.558 191.963 260.806 192.952 260.311C193.694 260.063 194.436 259.073 194.436 258.33V175.904C194.436 167.984 188.006 161.548 180.092 161.548H42.3436C34.4299 161.548 28 167.984 28 175.904V226.4Z"
              fill="url(#paint4_linear_10185_8005)"
            />
          </g>
          <g filter="url(#filter3_d_10185_8005)">
            <path
              d="M133.656 102.28C133.656 110.201 140.086 116.637 148 116.637H169.457C170.694 116.637 171.93 117.132 172.672 117.874L190.478 135.696C190.973 136.439 191.962 136.686 192.951 136.191C193.693 135.944 194.435 134.954 194.435 134.211V76.3565C194.435 68.4357 188.005 62 180.091 62H148C140.086 62 133.656 68.4357 133.656 76.3565V102.28Z"
              fill="url(#paint5_linear_10185_8005)"
            />
          </g>
          <path
            opacity="0.7"
            d="M163.275 193.727H53.9667C52.9775 193.727 51.9883 192.737 51.9883 191.747V185.311C51.9883 184.321 52.9775 183.331 53.9667 183.331H163.275C164.264 183.331 165.254 184.321 165.254 185.311V191.747C165.254 192.985 164.512 193.727 163.275 193.727Z"
            fill="url(#paint6_linear_10185_8005)"
          />
          <path
            opacity="0.7"
            d="M121.233 220.708H53.9667C52.9775 220.708 51.9883 219.717 51.9883 218.727V212.292C51.9883 211.302 52.9775 210.312 53.9667 210.312H121.233C122.223 210.312 123.212 211.302 123.212 212.292V218.727C123.212 219.965 122.47 220.708 121.233 220.708Z"
            fill="url(#paint7_linear_10185_8005)"
          />
          <g filter="url(#filter4_d_10185_8005)">
            <path
              d="M371.998 129.12C371.998 136.298 366.31 141.991 359.138 141.991H244.884C243.894 141.991 242.658 142.486 241.916 143.229L225.841 159.318C225.347 159.813 224.357 160.06 223.615 159.813C222.874 159.565 222.379 158.823 222.379 158.08V83.8225C222.379 76.6443 228.067 70.9512 235.239 70.9512H358.891C366.063 70.9512 371.751 76.6443 371.751 83.8225V129.12H371.998Z"
              fill="url(#paint8_linear_10185_8005)"
            />
          </g>
          <path
            opacity="0.7"
            d="M346.528 99.9138H248.348C247.359 99.9138 246.617 99.1712 246.617 98.1811V92.2405C246.617 91.2504 247.359 90.5078 248.348 90.5078H346.528C347.517 90.5078 348.259 91.2504 348.259 92.2405V98.1811C348.259 99.1712 347.517 99.9138 346.528 99.9138Z"
            fill="url(#paint9_linear_10185_8005)"
          />
          <path
            opacity="0.7"
            d="M308.938 124.168H248.348C247.359 124.168 246.617 123.426 246.617 122.436V116.495C246.617 115.505 247.359 114.762 248.348 114.762H308.938C309.927 114.762 310.669 115.505 310.669 116.495V122.436C310.669 123.178 309.68 124.168 308.938 124.168Z"
            fill="url(#paint10_linear_10185_8005)"
          />
          <path
            d="M164.096 73.3721C155.24 73.3721 148.125 80.5592 148.125 89.3435C148.125 98.1278 155.312 105.315 164.096 105.315C172.881 105.315 180.068 98.2004 180.068 89.3435C180.068 80.5592 172.953 73.4447 164.096 73.3721ZM170.195 81.4304C171.647 81.4304 172.808 82.5919 172.808 84.0439C172.808 85.4958 171.647 86.6574 170.195 86.6574C168.743 86.6574 167.581 85.4958 167.581 84.0439C167.581 82.5919 168.743 81.4304 170.195 81.4304ZM158.071 81.3578C159.523 81.3578 160.684 82.5193 160.684 83.9713C160.684 85.4232 159.523 86.5848 158.071 86.5848C156.619 86.5848 155.457 85.4232 155.457 83.9713C155.457 82.5919 156.619 81.3578 158.071 81.3578ZM173.316 93.046C171.356 98.1278 165.694 100.669 160.612 98.7812C157.998 97.7648 155.893 95.6595 154.877 93.046C154.659 92.3926 154.949 91.7392 155.603 91.5214C155.748 91.4488 155.893 91.4488 156.038 91.4488H172.155C172.808 91.4488 173.389 92.0296 173.389 92.683C173.389 92.7556 173.389 92.9008 173.316 93.046Z"
            fill="#474E61"
          />
          <defs>
            <filter
              id="filter0_d_10185_8005"
              x="91.3203"
              y="245.098"
              width="124.621"
              height="124.201"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="11" />
              <feGaussianBlur stdDeviation="11" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_10185_8005"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_10185_8005"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_d_10185_8005"
              x="200.379"
              y="145.599"
              width="126.847"
              height="126.673"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="11" />
              <feGaussianBlur stdDeviation="11" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_10185_8005"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_10185_8005"
                result="shape"
              />
            </filter>
            <filter
              id="filter2_d_10185_8005"
              x="6"
              y="150.548"
              width="210.436"
              height="143.02"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="11" />
              <feGaussianBlur stdDeviation="11" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_10185_8005"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_10185_8005"
                result="shape"
              />
            </filter>
            <filter
              id="filter3_d_10185_8005"
              x="129.656"
              y="62"
              width="68.7783"
              height="82.4487"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_10185_8005"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_10185_8005"
                result="shape"
              />
            </filter>
            <filter
              id="filter4_d_10185_8005"
              x="200.379"
              y="59.9512"
              width="193.619"
              height="132.959"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="11" />
              <feGaussianBlur stdDeviation="11" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_10185_8005"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_10185_8005"
                result="shape"
              />
            </filter>
            <linearGradient
              id="paint0_linear_10185_8005"
              x1="153.605"
              y1="254.243"
              x2="153.605"
              y2="337.164"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#5C6479" />
              <stop offset="0.9964" stopColor="#5C6479" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_10185_8005"
              x1="154.221"
              y1="313.848"
              x2="154.221"
              y2="310.866"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#8E94A7" />
              <stop offset="0.9913" stopColor="#6C707C" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_10185_8005"
              x1="263.775"
              y1="154.687"
              x2="263.775"
              y2="240.164"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#5C6479" />
              <stop offset="0.9964" stopColor="#5C6479" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_10185_8005"
              x1="264.878"
              y1="216.164"
              x2="264.878"
              y2="210.589"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#8E94A7" />
              <stop offset="0.9913" stopColor="#6C707C" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_10185_8005"
              x1="111.164"
              y1="159.257"
              x2="111.164"
              y2="261.636"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#5C6479" />
              <stop offset="0.9964" stopColor="#5C6479" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_10185_8005"
              x1="147.598"
              y1="81.5428"
              x2="182.333"
              y2="129.55"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#E3EAF7" />
              <stop offset="1" stopColor="#ADB6C8" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_10185_8005"
              x1="168.281"
              y1="188.499"
              x2="52.7869"
              y2="188.499"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.00651336" stopColor="#A6AEBE" stopOpacity="0" />
              <stop offset="1" stopColor="#A6AAB5" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_10185_8005"
              x1="125.116"
              y1="215.48"
              x2="52.4905"
              y2="215.48"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.00651336" stopColor="#A6AEBE" stopOpacity="0" />
              <stop offset="1" stopColor="#A6AAB5" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_10185_8005"
              x1="297.14"
              y1="68.8935"
              x2="297.14"
              y2="160.869"
              gradientUnits="userSpaceOnUse">
              <stop stopColor="#5C6479" />
              <stop offset="0.9964" stopColor="#5C6479" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_10185_8005"
              x1="350.976"
              y1="95.1838"
              x2="247.334"
              y2="95.1838"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.00651336" stopColor="#A6AEBE" stopOpacity="0" />
              <stop offset="1" stopColor="#A6AAB5" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_10185_8005"
              x1="312.381"
              y1="119.438"
              x2="247.069"
              y2="119.438"
              gradientUnits="userSpaceOnUse">
              <stop offset="0.00651336" stopColor="#A6AEBE" stopOpacity="0" />
              <stop offset="1" stopColor="#A6AAB5" />
            </linearGradient>
          </defs>
        </svg>
      )}
    </EmptyContainer>
  );
};
